import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import commonState from "./common/state";
import commonMutations from "./common/mutations";
import commonActions from "./common/actions";

Vue.use(Vuex);

const common = {
  namespaced: true,
  state: commonState,
  mutations: commonMutations,
  actions: commonActions
};
export default new Vuex.Store({
  modules: {
    common
  },
  plugins: [
    createPersistedState({
      paths: ["common"]
    })
  ]
});



// WEBPACK FOOTER //
// ./src/store/index.js